"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages = void 0;
/** @ignore */
exports.messages = {
    callbackIsNotFunction: 'The provided callback is not a function',
    dragDropInitFailed: 'Unable to initialize drag-drop',
    dragDropInitFailedInit: 'Unable to initialize drag-drop as part of init flow',
    failedToGenerateIframe: 'Unable to generate IFRAME for download. Using new window',
    getInstallerError: 'Unable to get latest installers',
    getAllTransfersFailed: 'Unable to get all transfers',
    getTransferFailed: 'Unable to get transfer',
    failedToGetDownloadUrl: 'Unable to retrieve HTTP download URL',
    invalidEndpoint: 'The specified endpoint is not a valid URL',
    loadingProtocol: 'Launching IBM Aspera for Desktop',
    modifyTransferFailed: 'Unable to modify transfer',
    notValidTransferSpec: 'The supplied transferSpec is not valid',
    removeTransferFailed: 'Unable to remove transfer',
    resumeTransferFailed: 'Unable to resume transfer',
    serverError: 'Unable to connect to IBM Aspera for Desktop server',
    serverNotVerified: 'IBM Aspera SDK has not been verified. Run test or init first',
    setBrandingFailed: 'Unable to set custom branding',
    showDirectoryFailed: 'Unable to show transfer directory',
    showSelectFileDialogFailed: 'Unable to show select file dialog',
    showSelectFolderDialogFailed: 'Unable to show select folder dialog',
    showPreferencesFailed: 'Unable to show preferences',
    stopTransferFailed: 'Unable to stop transfer',
    stopTransferFailedExternal: 'Unable to stop transfer. The download must be cancelled from the browser\'s download manager',
    transferFailed: 'The transfer failed to initiate',
    unableToFindElementOnPage: 'Unable to find the element on the current page',
    unableToReadDropped: 'The dropped item could not be parsed. Please try selecting via the select file/folder option',
    websocketClosedError: 'The websocket was closed due to an error',
    websocketClosedUnexpect: 'The websocket was closed unexpectedly',
    websocketNotReady: 'The websocket is not ready. Run init first',
    httpNotAvailable: 'IBM Aspera HTTP Gateway is not available',
    httpInitFail: 'IBM Aspera HTTP Gateway could not be started',
    filePickerCancel: 'User cancelled the select file or folder dialog.',
    fileNotAllowed: 'The specified path has not been allowed by the user.',
    httpNetworkFail: 'HTTP network encountered unknown error.',
    readAsArrayBufferFailed: 'Unable to read file as array buffer',
    readChunkAsArrayBufferFailed: 'Unable to read file chunk as array buffer',
    rpcDiscoverFailed: 'Unable to discover RPC endpoints',
    getFilesListFailed: 'Unable to get files list for transfer',
    getChecksumFailed: 'Unable to get file checksum',
    getChecksumNotSupported: 'File checksum not supported for current transfer client',
    showAboutFailed: 'Unable to show about page',
    showAboutNotSupported: 'Show about is not supported for current transfer client',
    readDirectoryFailed: 'Unable to read directory contents',
    readDirectoryNotSupported: 'Read directory is not supported for current transfer client',
    showTransferManagerFailed: 'Unable to show transfer manager',
    showTransferManagerNotSupported: 'Show transfer manager is not supported for current transfer client',
    openPreferencesPageFailed: 'Unable to open preferences page',
    openPreferencesPageNotSupported: 'Open preferences page is not supported for current transfer client',
    showTransferMonitorFailed: 'Unable to show transfer monitor',
    showTransferMonitorNotSupported: 'Show transfer monitor is not supported for current transfer client',
    authenticateFailed: 'Unable to authenticate',
    authenticateNotSupported: 'Authenticate is not supported for current transfer client',
    testSshPortsFailed: 'Unable to test SSH ports',
    testSshPortsNotSupported: 'Test SSH ports is not supported for current transfer client',
    showSaveFileDialogFailed: 'Unable to show save file dialog',
    showSaveFileDialogNotSupported: 'Show save file dialog is not supported for current transfer client',
};
